import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-super-admin',
  templateUrl: './super-admin.component.html',
  styleUrls: ['./super-admin.component.scss']
})
export class SuperAdminComponent implements OnInit {
  organizations = [];
  loading = false;
  showCreateDialog = false;
  newOrg = {
    name: '',
    domain: '',
    contactName: ''
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    public authService: AuthService
  ) {}

  ngOnInit() {
    this.loadOrganizations();
  }

  loadOrganizations() {
    this.loading = true;
    this.http.get(`${environment.apiBaseUrl}/v1/super-admin/organizations`, {
      headers: {
        'X-ACCESS-TOKEN': this.authService.getToken()
      }
    }).toPromise().then((orgs: any) => {
      this.organizations = orgs || [];
      this.loading = false;
    }).catch((error) => {
      console.error('Error loading organizations:', error);
      this.loading = false;
    });
  }

  createOrganization() {
    if (!this.newOrg.name || !this.newOrg.domain) {
      return;
    }

    this.loading = true;
    this.http.post(`${environment.apiBaseUrl}/v1/super-admin/organizations`, this.newOrg, {
      headers: {
        'X-ACCESS-TOKEN': this.authService.getToken(),
        'Content-Type': 'application/json'
      }
    }).toPromise().then(() => {
      this.showCreateDialog = false;
      this.newOrg = { name: '', domain: '', contactName: '' };
      this.loadOrganizations();
    }).catch((error) => {
      console.error('Error creating organization:', error);
      this.loading = false;
    });
  }

  deleteOrganization(orgId: string) {
    if (!confirm('Are you sure you want to delete this organization?')) {
      return;
    }

    this.loading = true;
    this.http.delete(`${environment.apiBaseUrl}/v1/super-admin/organizations/${orgId}`, {
      headers: {
        'X-ACCESS-TOKEN': this.authService.getToken()
      }
    }).toPromise().then(() => {
      this.loadOrganizations();
    }).catch((error) => {
      console.error('Error deleting organization:', error);
      this.loading = false;
    });
  }

  editOrganization(org: any) {
    // Navigate to organization settings or open edit dialog
    console.log('Edit organization:', org);
  }
}
